// extracted by mini-css-extract-plugin
export var header = "pages-module--header--aENkc";
export var hero_text = "pages-module--hero_text--xNCVb";
export var img_ability_clinic = "pages-module--img_ability_clinic--giChp";
export var start_sect_header = "pages-module--start_sect_header--Gjv0p";
export var steps = "pages-module--steps--UQqrU";
export var steps_circle = "pages-module--steps_circle--llGYL";